<template>
    <div class="my-8">
        <v-select v-model="selectedTypes" :label="label" :items="items" multiple color="zoezi-edit-color">
            <template slot="selection" slot-scope="data">
                <span class="mr-2"><v-icon left>{{data.item.icon}}</v-icon>  {{$translate(data.item.text)}}</span>
            </template>

            <template slot="item" slot-scope="data">
                <v-list-item v-on="data.on" v-bind:attrs="data.attrs" dense color="zoezi-edit-color">
                    <v-checkbox v-model="data.item.selected" dense class="mt-0" color="zoezi-edit-color">
                        <template slot="label">
                            <v-icon left>{{data.item.icon}}</v-icon>  {{$translate(data.item.text)}}
                        </template>
                    </v-checkbox>
                </v-list-item>
            </template>
        </v-select>

        <v-autocomplete v-if="selectedTypes.includes('card')" v-model="selectedCards" multiple :items="cards" item-text="name" item-value="id" :label="$translate('Training card')" :hint="$translate('Visible if the user has any of the selected training cards')" @input="emitChange" color="zoezi-edit-color" />

        <v-autocomplete v-if="selectedTypes.includes('role')" v-model="selectedRoles" multiple :items="roles" item-text="name" item-value="id" :label="$translate('Roles')" :hint="$translate('Visible if the user has any of the selected roles')" @input="emitChange" color="zoezi-edit-color" item-color="zoezi-edit-color" persistent-hint />

        <v-autocomplete v-if="selectedTypes.includes('permission')" v-model="selectedPermissions" multiple :items="permissions" item-text="name" item-value="id" :label="$translate('Access rights')" :hint="$translate('Visible if the user has all selected permissions')" @input="emitChange" color="zoezi-edit-color" item-color="zoezi-edit-color" persistent-hint />

        <template v-if="selectedTypes.includes('advanced')">
            <label class="v-label theme--light">{{$translate('JavaScript function')}}</label>
            <codemirror
                v-model="code"
                :options="cmOptionJs"
                @input="emitChange"
                style="border: 1px solid gray"
            />
            <div style="color: red">{{jsError}}</div>
        </template>
    </div>
</template>

<script>

function loadTrainingCards() {
    return window.$zoeziapi.get('/api/trainingcard/type/get/all').then(products => products.filter(p => p.type == 'trainingcard' || p.type == 'resourcebooking'));
}

function loadRoles() {
    return window.$zoeziapi.get('/api/staff/roles')
}

function loadPermissions() {
    return window.$zoeziapi.get('/api/staff/permissions/get', {builtIn: true})
}

import {difference} from 'lodash';
export default {
    name: 'VisiblitySetting',

    props: ['value', 'label'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.code = null;
                this.selectedCards = [];
                this.selectedRoles = [];
                this.selectedPermissions = [];
                if (!value) {
                    this.selectedTypes = ['always'];
                } else if (typeof value === 'string') {
                    this.selectedTypes = ['advanced'];
                    this.code = value;
                } else if (typeof value === 'object') {
                    this.selectedTypes = Array.isArray(value.type) ? value.type : [value.type];
                    this.code = value.code;
                    this.selectedCards = value.cards;
                    this.selectedRoles = value.roles;
                    this.selectedPermissions = value.permissions;
                }

                this.items.forEach(x => {
                    x.selected = this.selectedTypes.includes(x.value);
                });
            }
        },
        code: {
            immediate: true,
            handler() {
                this.checkJs();
            }
        },
        selectedTypes(newValue, oldValue) {
            if (newValue.length > oldValue.length) {
                // added
                let added = difference(newValue, oldValue);

                added.forEach(nv => {
                    let toremove = this.items.find(x => x.value == nv).ifSelectedRemove.split(',');
                    toremove.forEach(tr => {
                        if (tr == '*') {
                            this.selectedTypes = [nv];
                        } else {
                            let n = this.selectedTypes.indexOf(tr);
                            if (n !== -1) {
                                this.selectedTypes.splice(n, 1);
                            }
                        }
                    });
                })
            } else if (newValue.length == 0) {
                this.selectedTypes = ['always'];
            }

            this.items.forEach(x => {
                x.selected = this.selectedTypes.includes(x.value);
            });

            this.emitChange();
        }
    },

    data: () => ({
        selectedTypes: null,
        code: null,
        selectedCards: [],
        selectedRoles: [],
        selectedPermissions: [],

        cards: [],
        roles: [],
        permissions: [],

        items: [
            {value: 'always', text: 'Always show', icon: 'mdi-eye', selected: false, ifSelectedRemove: '*'},
            {value: 'never', text: 'Never show', icon: 'mdi-eye-off', selected: false, ifSelectedRemove: '*'},
            {value: 'isLoggedIn', text: 'Show if logged in', icon: 'mdi-door-open', selected: false, ifSelectedRemove: 'isNotLoggedIn,always,never'},
            {value: 'isNotLoggedIn', text: 'Show if logged out', icon: 'mdi-door-closed', selected: false, ifSelectedRemove: 'isLoggedIn,always,never'},
            {value: 'desktop', text: 'Show on computer', icon: 'mdi-desktop-mac', selected: false, ifSelectedRemove: 'mobile,always,never'},
            {value: 'mobile', text: 'Show on mobile', icon: 'mdi-cellphone-iphone', selected: false, ifSelectedRemove: 'desktop,always,never'},
            {value: 'card', text: 'Show for certain training card', icon: 'mdi-card-bulleted-outline', selected: false, ifSelectedRemove: 'always,never'},
            {value: 'role', text: 'Show for a specific role', icon: 'mdi-account-group', selected: false, ifSelectedRemove: 'always,never'},
            {value: 'permission', text: 'Show for certain access right', icon: 'mdi-shield-account', selected: false, ifSelectedRemove: 'always,never'},
            {value: 'advanced', text: 'Advanced condition', icon: 'mdi-cog', selected: false, ifSelectedRemove: 'always,never'}
        ],
        cmOptionJs: {
            tabSize: 2,
            indentUnit: 2,
            matchBrackets: true,
            mode: 'text/javascript',
            readOnly: false,
            lineNumbers: false,
            lineWrapping: true,
            foldGutter: false,
            lint: {
                esversion: 11,
                asi: true
            },
            gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"]
        },
        jsError: null
    }),

    methods: {
        emitChange() {
            let value = {type: this.selectedTypes, code: this.code, cards: this.selectedCards, roles: this.selectedRoles, permissions: this.selectedPermissions};
            if (value.type.length == 1 && value.type[0] == 'always') {
                value = null;
            }
            this.$emit('input', value);
        },
        checkJs() {
            let f;
            this.jsError = null;

            if (!this.selectedTypes.includes('advanced') || !this.code) {
                return;
            }

            // Compilation
            try {
                f = new Function(this.code);
                f = f.bind({
                    $vuetify: this.$vuetify,
                    $store: this.$store,
                    $booking: this.$booking
                });
            } catch(e) {
                this.jsError = 'Compilation error: ' + e;
            }

            if (f) {
                let res;
                // Execution
                try {
                    res = f();
                    if (typeof res !== 'boolean') {
                        this.jsError = 'Function should return a boolean value, not ' + (typeof res);
                    }
                } catch(e) {
                    this.jsError = 'Execution error: ' + e;
                }
            }
        }
    },
    created() {
        loadTrainingCards().then(x => this.cards = x.sort((a,b) => a.name.localeCompare(b.name)) )
        loadRoles().then(x => this.roles = x.map(y => ({...y, name: this.$translate(y.name)})).sort((a,b) => a.name.localeCompare(b.name)))
        loadPermissions().then(x => this.permissions = x.map(p => ({id: p.id, name: this.$translate(p.id)})).sort((a,b) => a.name.localeCompare(b.name)))
    }
}
</script>
